export default __webpack_public_path__ + "static/media/img-29.1502052e.jpg";